import { render } from "./Value1Section.vue?vue&type=template&id=72b7101e&scoped=true"
import script from "./Value1Section.vue?vue&type=script&lang=js"
export * from "./Value1Section.vue?vue&type=script&lang=js"

import "./Value1Section.vue?vue&type=style&index=0&id=72b7101e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b7101e"]])

export default __exports__